/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Geringfuegigebeschaeftigung1Inputs */



/**

* @param {_Field_Geringfuegigebeschaeftigung1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_geringfuegigebeschaeftigung1 = /** @type {((inputs?: _Field_Geringfuegigebeschaeftigung1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Geringfuegigebeschaeftigung1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Geringfügige Beschäftigung")
});
export { _field_geringfuegigebeschaeftigung1 as "_field_geringfuegigeBeschaeftigung" }